import {Component, Input, OnInit} from '@angular/core';
import { OrderedItem } from '../interface/ordered-item';
import { SelectedFinishProfileItem } from '../interface/selected-finish-profile-item';
import { CustomSize } from 'src/app/cart/interface/custom-size';
import { Router } from '@angular/router';
import { MatDialog } from "@angular/material/dialog";
import { CreateReviewDialogComponent } from "../../review/create-review-dialog/create-review-dialog.component";

@Component({
	selector: 'fb-instock-ordered-item',
	templateUrl: './instock-ordered-item.component.html',
	styleUrls: ['./instock-ordered-item.component.scss']
})
export class InstockOrderedItemComponent implements OnInit {

	@Input() reviewOrderItemId: number = 0;
	@Input() product: OrderedItem = {} as OrderedItem;
	@Input() inStockOrederItem: OrderedItem[] = [];

	constructor(
		private _router: Router,
		private _dialog: MatDialog
	) {
	}

	ngOnInit(): void {
		if (this.product.id && this.product.id == this.reviewOrderItemId) {
			this.onAddReview();
		}
	}

	public navigate(
		orderedItem: OrderedItem,
	): void {


		let slug = orderedItem.customization.fabricProductPreview ? 'fabric-product/' + orderedItem.customization.fabricProductPreview.product.slug :
			'finished-product/' + orderedItem.customization.finishedProductPreview!.product.slug;

		this._router.navigate(['../../product/' + slug])
	}

	public prepareCustomSizeLabel(customSizeData: CustomSize): string {

		let listOfLabel: string[] = [];
		let label: string = '';

		for (const [key, value] of Object.entries(customSizeData)) {
			// console.log(key, value);
			listOfLabel.push(`${key}: ${value}`);
		}

		label = listOfLabel.join();

		return label;
	}

	public prepareFinishLabel(selectedFinishItems: SelectedFinishProfileItem[]): string {

		let listOfLabel: string[] = [];
		let label: string = '';

		selectedFinishItems.forEach((selectedFinishItems: SelectedFinishProfileItem) => {
			listOfLabel.push(selectedFinishItems.label);
		});

		label = listOfLabel.join();

		return label
	}


	public onAddReview(): void {
		const dialog = this._dialog.open(
			CreateReviewDialogComponent,
			{
				width: '600px',
				data: this.product
			}
		);
	}
}
